'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';
import BodyLink from '@jouzen/ecom-components/v3/BodyLink';
import { List } from '@jouzen/ecom-components/v3/List';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';
import SimpleHero from '@/app/components/SimpleHero';
import SimpleTwoColumnModule from '@/app/components/SimpleTwoColumnModule';

const renderSupportLink = (chunks: React.ReactNode) => (
  <BodyLink
    href="https://support.ouraring.com/hc/articles/4402031939475-Caring-for-Your-Oura-Ring"
    target="_blank"
  >
    {chunks}
  </BodyLink>
);

const paragraph = (chunks: React.ReactNode) => (
  <Typography variant="body-large">{chunks}</Typography>
);

const Content = () => {
  const t = useTranslations();

  return (
    <>
      <InverseHeader enter>
        <SimpleHero
          artDirectionImageProps={{
            localizedAlt: 'ceramic_hero_alt',
            srcSet: [
              {
                media: '(max-width: 1023px)',
                src: 'ceramic-care/ceramic-care-hero-mobile.jpg',
              },
              {
                media: '(min-width: 1024px)',
                src: 'ceramic-care/ceramic-care-hero-desktop.jpg?ar=16:9&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=0.7',
              },
            ],
          }}
          eyebrowMessageKey="cleaning_and_care"
          data-cy="ceramic-hero"
          textColor="light"
          titleMessageKey="or4_ceramic_care"
        />
      </InverseHeader>
      <SimpleTwoColumnModule
        className="pt-20 pb-12"
        data-cy="about-section"
        heading={{ content: 'about_zirconia_ceramic_title' }}
      >
        <Typography className="text-lg" Element="div">
          <RichText
            messageKey="about_zirconia_ceramic_copy"
            tValues={{
              p: paragraph,
            }}
          />
        </Typography>
      </SimpleTwoColumnModule>
      <SimpleTwoColumnModule
        data-cy="look-best-section"
        heading={{ content: 'keep_ring_looking_best_title' }}
      >
        <Typography className="text-lg">
          {t('keep_ring_looking_best_list_fragment')}
        </Typography>
        <List className="text-lg">
          <RichText messageKey="keep_ring_looking_best_list" />
        </List>
        <Typography className="text-lg">
          {t('keep_ring_looking_best_copy')}
        </Typography>
      </SimpleTwoColumnModule>
      <SimpleTwoColumnModule
        data-cy="cleaning-instructions-section"
        heading={{ content: 'cleaning_care_instructions_title' }}
      >
        <Typography className="text-lg" Element="div">
          <RichText
            messageKey="cleaning_care_instructions_copy"
            tValues={{
              a: renderSupportLink,
              p: paragraph,
            }}
          />
        </Typography>
      </SimpleTwoColumnModule>
    </>
  );
};

export default Content;
